var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiQrCodeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3718 17.334V16.3324H13.367V13.3276H16.3718V15.3308H18.3751V17.334H17.3735V19.3372H15.3702V21.3404H13.367V18.3356H15.3702V17.334H16.3718ZM21.3799 21.3404H17.3735V19.3372H19.3767V17.334H21.3799V21.3404ZM3.35101 3.31158H11.3638V11.3244H3.35101V3.31158ZM5.35422 5.31479V9.3212H9.36063V5.31479H5.35422ZM13.367 3.31158H21.3799V11.3244H13.367V3.31158ZM15.3702 5.31479V9.3212H19.3767V5.31479H15.3702ZM3.35101 13.3276H11.3638V21.3404H3.35101V13.3276ZM5.35422 15.3308V19.3372H9.36063V15.3308H5.35422ZM18.3751 13.3276H21.3799V15.3308H18.3751V13.3276ZM6.35582 6.31639H8.35903V8.3196H6.35582V6.31639ZM6.35582 16.3324H8.35903V18.3356H6.35582V16.3324ZM16.3718 6.31639H18.3751V8.3196H16.3718V6.31639Z",
    fill: "#383E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiQrCodeLine);
export default __webpack_public_path__ + "static/media/ri_qr-code-line.869eed7b976d9e91b9b21441064cafb1.svg";
export { ForwardRef as ReactComponent };